// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#667eea",
          secondary: "#b0bec5",
          success: "#4caf50",
          error: "#f44336",
          info: "#2196f3",
          warning: "#fb8c00",
        },
      },
    },
  },
});
